module.exports = __webpack_public_path__ + "img/1234567894.970f43b8.png";